module.exports = __webpack_public_path__ + "static/error-illustration-441def3a0fbe3978d5a3cbba57f11de0.svg";